import axios from "axios"

const controller = "/ordenVentaPago"

const OrdenVentaPagoService = {
    registrar: async (request) => {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    adjuntar: async (file, ovp_id) => {
        let form = new FormData()
        form.append("file", file)
        form.append("ovp_id", ovp_id)
        const { data } = await axios.post(`${controller}/adjuntar`, form)
        return data
    },
    cancelar: async (request) => {
        const { data } = await axios.post(`${controller}/cancelar`, request)
        return data
    },
}

export default OrdenVentaPagoService